import { RestBase } from './base'
import { Party } from '@/ts/interfaces/party'
import { Error } from '@/ts/interfaces/error'
import { FrontendData } from '@/ts/interfaces/frontend-data'
import { FollowRaw } from '@/ts/interfaces/follow'

export class RestParty {
  private rest: RestBase

  constructor() {
    this.rest = new RestBase()
  }

  public edit(id: number, name: string, votingEnabled: boolean, autoStart: boolean, wpPostId: string | null, frontendData: FrontendData, follow: FollowRaw, loginRequired: boolean): Promise<Party> {
    return this.rest.put(`/api/parties/${id}`, {
      body: {
        name,
        voting_enabled: votingEnabled,
        auto_start: autoStart,
        wp_post_id: wpPostId,
        frontend: frontendData,
        follow,
        login_required: loginRequired
      },
      withCmsAuth: true
    })
  }

  public get(id: number): Promise<Party> {
    return this.rest.get(`/api/parties/${id}`, { withCmsAuth: true })
  }

  public start(token: string, id: number): Promise<void> {
    return this.rest.post(`/api/parties/${id}/start`, { headers: this.rest.bearerAuthorizationHeader(token), })
  }

  public stop(id: number) {
    return this.rest.post(`/api/parties/${id}/stop`, { withCmsAuth: true })
  }

  public end(id: number): Promise<Party> {
    return this.rest.post(`/api/parties/${id}/end`, { withCmsAuth: true })
  }

  public searchAlbum(albumId: string, service: string, country: string): Promise<any | Error> {
    const url = service === 'spotify' ? `/api/${service}/albums/${albumId}` : `/api/${service}/albums/${country}/${albumId}`

    return this.rest.get(url)
  }

  public searchPlaylist(playlistId: string, service: string, country: string): Promise<any | Error> {
    const url = service === 'spotify' ? `/api/${service}/playlists/${playlistId}` : `/api/${service}/playlists/${country}/${playlistId}`

    return this.rest.get(url)
  }

  public searchArtist(artistId: string): Promise<any | Error> {
    return this.rest.get(`/api/spotify/artists/${artistId}`)
  }
}
